import React from "react";
// @ts-ignore
import classNames from 'classnames';
import styled from "styled-components";


const StyledContent = styled.div`
  background-color: white;
  display: block;
  height: 93vh;

  &.hidden {
    display: none;
  }
`;

interface ContentProps {
  children: React.ReactNode,
  isSidebarOpen: boolean,
}

const Content = ({ children, isSidebarOpen }: ContentProps) => {
  return (
    <StyledContent className={classNames({ hidden: isSidebarOpen })}>
      { children }
    </StyledContent>
  );
};

export default Content;
